export function Ratio4x3Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="18.125" y="3.75" width="12.5" height="16.25" rx="2" transform="rotate(90 18.125 3.75)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio4x3Icon.displayName = 'Ratio4x3Icon';
